import React from 'react';
import { OrderAddress } from '~/lib/data-contract/salesforce';
import { StyledFullName } from '../styled';
import { Defaults } from '~/features/checkout/models/checkout';

type Props = {
    billingAddress: OrderAddress;
    sameDeliveryAddress: boolean;
    methods: any;
};

export const SavedAddress = ({ billingAddress, sameDeliveryAddress, methods }: Props) => {
    const formValues = methods.getValues();

    return (
        <>
            {sameDeliveryAddress ? (
                <div>
                    <StyledFullName>{billingAddress?.fullName}</StyledFullName>
                    <p>
                        {billingAddress?.address1} {billingAddress?.address2}
                    </p>
                    <p>
                        {billingAddress?.postalCode} {billingAddress?.city}
                    </p>
                    {billingAddress?.phone !== Defaults.phoneNumber && (
                        <p>{billingAddress?.phone}</p>
                    )}
                </div>
            ) : (
                <div>
                    <StyledFullName>{`${formValues?.firstName} ${formValues?.lastName}`}</StyledFullName>
                    <p>{formValues?.address1}</p>
                    <p>
                        {formValues?.postalCode} {formValues?.city}
                    </p>
                    <p>{formValues?.phoneMobile}</p>
                </div>
            )}
        </>
    );
};
